import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Normalizes a hex color value to always start with "#".
 * Handles values with or without the leading "#", and null/undefined.
 */
export function normalizeColorHex(colorHex: string | null | undefined): string | undefined {
  if (!colorHex) return undefined;
  return colorHex.startsWith('#') ? colorHex : `#${colorHex}`;
}

/**
 * Capitalizes the first letter of the first word in a string
 * @param str - The string to capitalize
 * @returns The string with the first letter capitalized
 * @example
 * capitalizeFirst('hello world') // 'Hello world'
 * capitalizeFirst('HELLO WORLD') // 'Hello world'
 */
export function capitalizeFirst(str: string | null | undefined): string {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
